import { OrganisationIcon } from '@/const'
import {
  ClipboardTextLtr24Regular,
  Desktop24Regular,
  MailInbox24Regular,
  PeopleTeam24Regular,
  Person24Regular,
} from '@fluentui/react-icons'
import { IconLabsOutline } from '@icons/IconLabsOutline'
import { IconWalletOutline } from '@icons/IconWalletOutline'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { DEFAULT_HEADER_STATE, useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { useSessionStorage } from '@/hooks'
import { hasSubscriptionAccess } from '@/util'

export function SubscriptionNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  const { name } = useCurrentOrganisation()
  const [userRole] = useSessionStorage('roles', 1)
  useSetHeaderContext({
    ...DEFAULT_HEADER_STATE,
    rightTitle: name ? { text: name, icon: OrganisationIcon } : undefined,
  })

  const navigation = [
    { title: 'Details', Icon: OrganisationIcon, path: '.', visible: true },
    { title: 'Users', Icon: Person24Regular, path: 'users', visible: true },
    { title: 'Projects', Icon: ClipboardTextLtr24Regular, path: 'projects', visible: true },
    { title: 'Teams', Icon: PeopleTeam24Regular, path: 'teams', visible: true },
    { title: 'Workspaces', Icon: Desktop24Regular, path: 'workspaces', visible: true },
    { title: 'AI Gateways', Icon: IconLabsOutline, path: 'ai-gateways', visible: true },
    {
      title: 'Token limits',
      Icon: IconWalletOutline,
      path: 'token-limits',
      visible: hasSubscriptionAccess(userRole),
    },
    { title: 'Requests', Icon: MailInbox24Regular, path: 'requests', visible: true },
  ]

  return <FlatSidebarMenu items={navigation} sidebarOpen={sidebarOpen} />
}
